// TODO:
// - add a scope feature?
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["debug"] = 0] = "debug";
    LogLevel[LogLevel["information"] = 1] = "information";
    LogLevel[LogLevel["warning"] = 2] = "warning";
    LogLevel[LogLevel["error"] = 3] = "error";
    LogLevel[LogLevel["critical"] = 4] = "critical";
})(LogLevel || (LogLevel = {}));
